import { formatDateTime } from "@/lib/api";

export const printApplication = (a) => {
  const esc = (s) => String(s ?? "").replace(/[<>&]/g, (c) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;" }[c]));
  const rows = [
    ["Applicant", a.renter_name], ["Full name", a.full_name], ["Email", a.renter_email], ["Property", a.property_title],
    ["Move-in date", a.move_in_date],
    ["Employer", a.employer], ["Employer address", a.employer_address],
    ["Supervisor name", a.supervisor_name], ["Supervisor phone", a.supervisor_phone],
    ["Annual income", a.annual_income ? `$${Number(a.annual_income).toLocaleString()}` : ""],
    ["Monthly income", a.monthly_income ? `$${Number(a.monthly_income).toLocaleString()}` : ""],
    ["Notes", a.notes],
  ];
  (a.template_questions || []).forEach((q) => {
    let v = (a.answers || {})[q.id];
    if (q.type === "yes_no") v = v === true || v === "true" || v === "yes" ? "Yes" : v === false || v === "false" || v === "no" ? "No" : v;
    rows.push([q.label, v]);
  });
  const html = `<html><head><title>Application — ${esc(a.renter_name)}</title>
    <style>body{font-family:-apple-system,Segoe UI,Roboto,sans-serif;color:#1a1a1a;padding:40px;max-width:720px;margin:auto}
    h1{font-size:22px;margin-bottom:4px}.sub{color:#666;margin-bottom:24px}
    table{width:100%;border-collapse:collapse}td{padding:10px 8px;border-bottom:1px solid #eee;vertical-align:top}
    td.k{font-weight:600;width:38%;color:#333}</style></head><body>
    <h1>Rental Application</h1><div class="sub">Submitted ${esc(formatDateTime(a.submitted_at || a.created_at) || "")}</div>
    <table>${rows.filter(([, v]) => v !== undefined && v !== null && v !== "").map(([k, v]) => `<tr><td class="k">${esc(k)}</td><td>${esc(v)}</td></tr>`).join("")}</table>
    </body></html>`;
  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  iframe.srcdoc = html;
  iframe.onload = () => {
    try { iframe.contentWindow.focus(); iframe.contentWindow.print(); } catch (e) { console.error("Print failed", e); }
    setTimeout(() => iframe.remove(), 1000);
  };
  document.body.appendChild(iframe);
};

export const DEFAULT_DECLINE = (a) =>
  `Hi ${(a.renter_name || "there").split(" ")[0]}, thank you so much for applying for ${a.property_title}. ` +
  "Unfortunately, an application submitted prior to yours was accepted, so this rental is no longer available. " +
  "We genuinely appreciate your interest and the time you took to apply. " +
  "If it becomes available again, we'd be glad to reach back out using the information on your application — " +
  "just reply here if you'd like us to keep you in mind. Wishing you all the best in your home search!";
